export default "__VITE_PUBLIC_ASSET__80d25806__"